module.exports = __webpack_public_path__ + "static/media/table-chairs-3.11696739.jpg";